import React, { useEffect, useState } from 'react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50); // 14:50 in seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-3 px-4 text-center font-bold text-sm md:text-base z-50 shadow-lg" data-id="element-87">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-4 flex-wrap" data-id="element-88">
        <span data-id="element-89">
          ⏳ OFERTA EXPIRA EN: {String(minutes).padStart(2, '0')}:
          {String(seconds).padStart(2, '0')}
        </span>
        <span className="hidden md:inline" data-id="element-90">|</span>
        <span data-id="element-91">🔥 SOLO QUEDAN 3 CUPOS</span>
      </div>
    </div>;
}